import groupBy from 'lodash/groupBy';
import { fetchJson } from '@atlassian/jira-fetch';
import type { ResourceStoreContext, RouterDataContext } from '@atlassian/jira-router';
import { getProjectKeyId } from '@atlassian/jira-router-resources-utils';
import type { CategorizedGroupData, PriorityGroup, QueueId } from '../../types';

type GroupResponse = PriorityGroup & {
	queueIds: QueueId[];
	category: string;
};

type GroupFetchResponse = {
	results: GroupResponse[];
};

export const fetchGroups = async (projectKey: string, cloudId: string) => {
	if (__SERVER__) {
		return fetchJson(
			`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectIdOrKey=${projectKey}`,
			{
				headers: {
					'x-ssr-service-name': 'jsm-kukama',
				},
			},
		);
	}
	return fetchJson(
		`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectIdOrKey=${projectKey}`,
	);
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (
	{ match, query }: RouterDataContext,
	{ tenantContext }: ResourceStoreContext,
) => {
	const { cloudId } = tenantContext;
	const projectKey = getProjectKeyId(match, query).projectKey;

	// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	const data: GroupFetchResponse = await fetchGroups(projectKey!, cloudId);

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const processedData = groupBy(
		data.results.map((group) => ({ ...group, queues: group.queueIds || [] })),
		'category',
	) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	return processedData as CategorizedGroupData;
};
